var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8C22 4.68629 19.3137 2 16 2H8C4.68629 2 2 4.68629 2 8V16C2 19.3137 4.68629 22 8 22H16C19.3137 22 22 19.3137 22 16V8ZM7.41435 10.4685C7.15559 10.1451 7.20803 9.67311 7.53148 9.41435C7.85493 9.15559 8.32689 9.20803 8.58565 9.53148L12 13.7994L15.4143 9.53148C15.6731 9.20803 16.1451 9.15559 16.4685 9.41435C16.792 9.67311 16.8444 10.1451 16.5857 10.4685L12.9761 14.9805C12.4757 15.606 11.5243 15.606 11.0239 14.9805L7.41435 10.4685Z",
    fill: "#A02E3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenedIcon);
export default __webpack_public_path__ + "static/media/OpenedIcon.a5bd8af3f38279ddf6992b06a77ff89b.svg";
export { ForwardRef as ReactComponent };